import { RegionId } from "@sp-crm/core";
import { useState } from "react";
import { AgendaSnooze } from "./agenda-snoozed-section";
import {
    AgendaCard,
    agendaContactGroups,
    AgendaFeed,
    mergeAgendaCards,
} from "./marketing-plan-agenda";

interface MergedAgenda {
    regionId: RegionId | null;
    feed: AgendaFeed | null;
    snoozes: AgendaSnooze[] | undefined;
    cards: AgendaCard[];
}

const emptyAgenda = (regionId: RegionId | null): MergedAgenda => ({
    regionId,
    feed: null,
    snoozes: undefined,
    cards: [],
});

const nextAgenda = (
    merged: MergedAgenda,
    regionId: RegionId | null,
    feed: AgendaFeed | undefined,
    snoozes: AgendaSnooze[] | undefined,
): MergedAgenda => {
    const current = merged.regionId === regionId ? merged : emptyAgenda(regionId);
    if (!feed || (feed === current.feed && snoozes === current.snoozes)) {
        return current;
    }
    return {
        regionId,
        feed,
        snoozes,
        cards: mergeAgendaCards(current.cards, {
            groups: agendaContactGroups(feed.contacts),
            snoozedContactIds: (snoozes ?? []).map(snooze => snooze.contactId),
            completedContactIds: feed.completedContactIds,
        }),
    };
};

export const useAgendaCards = (
    regionId: RegionId | null,
    feed: AgendaFeed | undefined,
    snoozes: AgendaSnooze[] | undefined,
): AgendaCard[] => {
    const [merged, setMerged] = useState<MergedAgenda>(() => emptyAgenda(regionId));
    const current = nextAgenda(merged, regionId, feed, snoozes);
    if (current !== merged) {
        setMerged(current);
    }
    return current.cards;
};
